export interface ILabelValue<TLabel, TValue> {
  label: TLabel;
  value: TValue;
}

export const byLabel = <TLabel, TType>(a: ILabelValue<TLabel, TType>, b: ILabelValue<TLabel, TType>) =>
  a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
